module.exports = __webpack_public_path__ + "img/honey.40006f46.svg";